import {Component, OnInit, ViewChildren, QueryList, Input, Output, EventEmitter, ElementRef, ViewChild, TemplateRef} from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { EventService } from "../../../core/services/event.service";
import { SharedService } from "src/app/core/services/shared.service";
import { FiltrocampoComponent } from "src/app/shared/ui/filtrocampo/filtrocampo.component";
import Swal from "sweetalert2";
import {
  NgbModal,
  NgbModalRef,
  NgbOffcanvas,
  NgbOffcanvasRef,
} from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MenuEvent } from "src/app/core/services/menuevent.service";
import { DropzoneComponent } from "../dropzone/dropzone.component";
import { FiltrocanvasComponent } from "../filtrocanvas/filtrocanvas.component";
import { formatDate } from "@angular/common";
import { MenuService } from "../../../core/services/menu.service";

@Component({
  selector: "app-advancetable-editable",
  templateUrl: "./advancetable-editable.component.html",
  styleUrls: ["./advancetable-editable.component.scss"],
})
export class AdvancetableEditableComponent implements OnInit {
  MostrarFiltroPrincipal: any;
  CNT05COD: any;
  M05COD: any;
  CNT05DES: any;
  M05DES: any;
  // mospina 21-10-26 Breadcrumb compañía/sede
  get companiaActual(): string { return localStorage.getItem("X-AVATAR-CNT05DES") || ''; }
  get sedeActual(): string { return localStorage.getItem("X-AVATAR-M05DES") || ''; }
  Mostrartitulofiltro = false;
  toolbar: any;
  tableData2: Array<any>;
  tableData3: Array<any> = [];
  estructura: Observable<any>;
  llaves: Array<string> = [];
  ColumnasSN = [];
  reportes: Array<string> = [];
  filtrosReporte: Array<string> = [];
  form_template$: Observable<any>;
  operaciones: any;
  boton: Array<string> = [];
  tipo: Array<string> = [];
  evento: Array<string> = [];
  tooltip: Array<string> = [];
  icono: Array<string> = [];
  ShowLoadingIndicator = true;
  currentPage: number;
  itemsPerPage: number = 10;
  number = [10, 20, 30, 40];
  public height = "100vh";
  intSYS02CON: string;
  strEventListener: string;
  blnFiltrosAbiertos: boolean = false;
  blnFiltrosAbiertosHorizontal: boolean = false;
  tipo_pantalla: string = "";
  favorito_pantalla: string = "";
  ActivarFiltro: string = "";
  ActivarFavorito: string = "";
  permitir_click_lista: string = "";
  UrlClickLista: string = ""; // almora 2021.11.20 URL para el click en la lista por default
  WsMsDataInterno: string = ""; // almora 2021.11.28 Data Para el Mantenimiento Intero
  strWsURLModal: string = "";
  WsLlavesModal: string = "";
  mostrarbreitem: boolean = false;
  MostrarReportes: string = "";
  listaReportes = null;
  tipoReporte = null;
  dashboard = { CHARTS: [], REPORTES: [] };
  respFiltros = [];
  respFiltrosAvanzados = [];
  toolbarcampomodal: any;
  UrlBottomBar: any;
  BottomBarData: any;
  blnAccionbuscar = 0;
  lineaEditar = -1;
  Select_grabar: any;
  SYS02TUT = "";
  SYS41ARC = [];

  @ViewChild("contenido") contenido: TemplateRef<any>;
  @ViewChild("contenidocampo") contenidocampo: TemplateRef<any>;

  index: number = 0;
  currentPDF: any;
  TituloPantalla: string = "";
  suscription: Subscription = null;
  safeURL: SafeResourceUrl;
  formFiltros = null;
  filtro_guardado = [];
  filtroSel = null;

  @Input() ToolbarSN: string[];
  @Input() breadCrumbItems: Array<{}>;
  @Input() WsURL: string = "";
  @Input() WsLlaves: any = "";
  @Input() MsDetalle: string = "N"; // almora 2021.11.21 Abrir en Detalle S/N, S cuando viene de NAVS, N por Default
  @Input() mostrarModal: boolean = false;
  @Input() A04CDE = null;
  @Input() SYS02CON_PAPA_LD: string; // almora 2024.06.19 Guardo SYS02CON de la tabla principal, se carga si soy Lista Detalle desde Wizard

  @Output() RetornoModal = new EventEmitter();
  @Output() AbrirNuevoNav = new EventEmitter<string>();

  @ViewChildren("chkTabla") objChecks: QueryList<ElementRef>;
  @ViewChild(FiltrocampoComponent) child: FiltrocampoComponent;

  order_mostrar: boolean = false;
  modalRef: NgbModalRef;
  offcanvasRef: NgbOffcanvasRef = null;

  constructor(
    private dataService: SharedService,
    public menuService: MenuService,
    private eventService: EventService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private menuEvent: MenuEvent,
    private offcanvasService: NgbOffcanvas
  ) {
    this.obtener_localstorage();
  }

  retornaObservable(form_template) {
    const obs$ = new Observable((observer) => {
      observer.next(form_template);
    });
    return obs$;
  }

  open() {
    this.offcanvasRef = this.offcanvasService.open(FiltrocanvasComponent, {
      backdrop: true,
      position: "end",
      scroll: true,
      backdropClass: "bg-transparent",
      panelClass: "scroll-canvas",
    });
    this.offcanvasRef.componentInstance.form_template = this.respFiltros;
    this.offcanvasRef.componentInstance.strListener = this.strEventListener;
    this.offcanvasRef.componentInstance.blnMostrarBusqueda =
      this.tipo_pantalla != "REPORTE";
    this.offcanvasRef.componentInstance.TipoPantalla = this.tipo_pantalla;
    this.offcanvasRef.componentInstance.Mostrartitulofiltro =
      this.Mostrartitulofiltro;
    this.offcanvasRef.componentInstance.formFiltros = this.formFiltros;
    this.offcanvasRef.componentInstance.reportes = this.reportes;
    this.offcanvasRef.componentInstance.WsLlaves = this.WsLlaves;
    this.offcanvasRef.componentInstance.SYS02CON = this.intSYS02CON;
    this.offcanvasRef.componentInstance.estructura = this.estructura;
    this.offcanvasRef.componentInstance.filtrosAvanzados =
      this.child?.DemeFormulario();
    this.offcanvasRef.result
      .then((result) => {
        this.formFiltros = result;
        this._fetchData(this.isObject(result) ? result : JSON.parse(result));
      })
      .catch(() => {});
    this.offcanvasRef.componentInstance.abrirNav.subscribe((json) => {
      this.AbrirNuevoNav.emit(json);
    });
  }

  ngOnInit() {
    this.obtener_localstorage();
    if (this.MostrarFiltroPrincipal == "false") {
      this.blnFiltrosAbiertosHorizontal;
    } else {
      this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    }
    this.Mostrartitulofiltro = true;
    this._fetchData();
  }

  cerrarmodal(event) {
    this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    this.obtener_localstorage();
  }

  /**
   * fetches the table value
   */

  _fetchData(filtros?: any) {
    this.ShowLoadingIndicator = true;

    if (filtros == null) filtros = JSON.parse("{}");

    if (this.WsLlaves == null || this.WsLlaves == "") this.WsLlaves = [];

    let objFiltros = JSON.parse(
      '{   "FILTROS_OPCIONALES"   : [' +
        JSON.stringify(this.formatearFormulario(filtros)) +
        "]" +
        (this.SYS02CON_PAPA_LD != null
          ? ', "SYS02CON_PAPA_LD" : ' + JSON.stringify(this.SYS02CON_PAPA_LD)
          : "") +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves) +
        "}"
    );

    this.dataService.ConsultarWS(this.WsURL, objFiltros).subscribe(
      (datosResp: any) => {
        // limpio todo
        this.llaves = [];
        this.ColumnasSN = [];
        this.boton = [];
        this.tipo = [];
        this.evento = [];
        this.tooltip = [];
        this.icono = [];

        this.permitir_click_lista = datosResp.PermitirClickLista;
        this.UrlClickLista = datosResp.UrlClickLista;
        this.UrlBottomBar = datosResp.UrlBottomBar;
        this.tableData2 = datosResp.DataTable;
        this.estructura = datosResp.Estructura;
        this.operaciones = datosResp.Operaciones;
        this.reportes = datosResp.Reportes;
        this.filtrosReporte = datosResp.Filtros;
        this.toolbar = datosResp.Toolbar;
        this.tipo_pantalla = datosResp.Tipo;
        this.favorito_pantalla = datosResp.Favorito;
        this.ActivarFiltro = datosResp.ActivarFiltro;
        this.ActivarFavorito = datosResp.ActivarFavorito;
        this.intSYS02CON = datosResp.SYS02CON;
        this.TituloPantalla = datosResp.SYS02DES;
        this.MostrarReportes = datosResp.MostrarReportes;
        this.Select_grabar = datosResp.SYS20ARC;
        this.SYS02TUT = datosResp.SYS02TUT;
        this.SYS41ARC = datosResp.SYS41ARC;
        if (datosResp.DashBoard != undefined) {
          if (datosResp.DashBoard.length > 0) {
            this.dashboard = datosResp.DashBoard[0];
          }
        }

        // Registro la subscription
        if (this.suscription == null) {
          this.strEventListener = this.intSYS02CON;
          localStorage.removeItem("busqueda" + this.strEventListener);
          this.suscription = this.eventService.subscribe(
            "EVENTO_REFRESAR_LISTA_" + this.strEventListener,
            (data) => {
              let busqueda = this.obtenerBusqueda(this.strEventListener);
              if (busqueda != null) {
                data = busqueda;
              } else {
                if (this.formFiltros != null) {
                  data = this.formFiltros;
                }
              }
              this._fetchData(this.isObject(data) ? data : JSON.parse(data));
            }
          );
        }

        for (let i = 0; i < datosResp.Estructura.length; i++) {
          if (datosResp.Estructura[i].A03PKY === "S") {
            this.llaves.push(datosResp.Estructura[i].A03COD);
          }

          if (datosResp.Estructura[i].A03VIS === "S") {
            this.ColumnasSN.push(datosResp.Estructura[i]);
          }

          if (
            datosResp.Estructura[i].A09AMF.length > 0 &&
            datosResp.Estructura[i].A03PKY == "N"
          ) {
            this.tableData3.push({
              codigo: datosResp.Estructura[i].A03COD,
              des: datosResp.Estructura[i].A09AMF,
            });
          }

          //loading frivera
          if (
            datosResp.Estructura.length != "" &&
            datosResp.Estructura.length > 0
          ) {
            this.ShowLoadingIndicator = false;
          } else {
            this.ShowLoadingIndicator = true;
          }
        }

        for (let j = 0; j < this.tableData2.length; j++) {
          this.tableData2[j].checkado = false;
          for (let k = 0; k < this.tableData3.length; k++) {
            if (this.tableData2[j][this.tableData3[k].codigo] != undefined) {
              for (let w = 0; w < this.tableData3[k].des.length; w++) {
                if (
                  this.tableData3[k].des[w].A09COD ==
                  this.tableData2[j][this.tableData3[k].codigo]
                ) {
                  this.tableData2[j][this.tableData3[k].codigo] =
                    this.tableData3[k].des[w].A09DES;
                }
              }
            }
          }
        }

        //frivera 11/08/2021 se creo un for para sacar las operaciones
        if (datosResp.Operaciones !== undefined) {
          for (let i = 0; i < datosResp.Operaciones.length; i++) {
            this.boton.push(datosResp.Operaciones[i].boton);
            this.tipo.push(datosResp.Operaciones[i].Tipo);
            this.evento.push(datosResp.Operaciones[i].Evento);
            this.tooltip.push(datosResp.Operaciones[i].Tooltip);
            this.icono.push(datosResp.Operaciones[i].icono);
          }

          if (this.mostrarModal) {
            this.form_template$ = this.retornaObservable(datosResp.Filtros);
          } else {
            this.respFiltros = datosResp.Filtros;
            this.respFiltrosAvanzados = datosResp.Filtros[0];
          }
        }

        // apago el loader
        this.ShowLoadingIndicator = false;

        this.formFiltros = JSON.parse(
          localStorage.getItem("filtro" + this.intSYS02CON)
        );

        this.Botonbar(this.WsLlaves);

        this.filtro_guardado = this.Select_grabar;
      },
      (error) => {
        Swal.fire({
          html:
            '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-8">' +
            "<h3>Error</h3><br>" +
            " <p>" +
            error +
            "</p>" +
            " </div> ",
        });
        localStorage.setItem(this.WsURL, "{}");
      }
    );
  }

  Botonbar(llaves) {
    if (this.UrlBottomBar != "") {
      let json = this.toJSON("SELECT", llaves, this.UrlBottomBar);
      this.dataService
        .ConsultarWS(this.UrlBottomBar, json)
        .subscribe((datosResp: any) => {
          this.BottomBarData = datosResp.CamposMS;
        });
    }
  }

  AbrirURL(json) {
    if (this.MsDetalle == "S") {
      // Abro un URL en mantenimiento interno
      this.WsMsDataInterno = json;
    } else {
      // Emito el evento para abrir un nuevo tab
      this.AbrirNuevoNav.emit(json);
    }
  }

  EventoClickToolbar(clicked, url, formato?) {
    if (clicked.target.id == "INSERT") {
      if (this.mostrarModal) {
        // El evento es un insert para grabar datos desde una lista modal
        let arr: any[] = [];
        let blnExiste: boolean = false;
        this.objChecks.forEach((objCheck) => {
          if (objCheck.nativeElement.checked) {
            let index = objCheck.nativeElement.value;
            if (index != -1) {
              let llaves = this.DemeLlavesIndexJSON(index);
              arr.push(llaves);
            }
            blnExiste = true;
          }
        });

        if (blnExiste) {
          let arrLlaves =
            '  "FILTROS_OPCIONALES"   : [{}]' +
            ', "FILTROS_OBLIGATORIOS" : ' +
            JSON.stringify(this.WsLlaves);

          var jsonFiltros = this.toJSON(
            clicked.target.id,
            arr,
            null,
            null,
            arrLlaves
          );

          this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
            (datosResp: any) => {
              // Recargo los datos de la lista MODAL
              this._fetchData();
            },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-4">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-8">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-8">' +
              "<h3>Error</h3><br>" +
              " <p>Debe seleccionar los registros con los que desea trabajar.</p>" +
              " </div> ",
          });
        }
      } else {
        // El evento es insert para abrir un mantenimiento en blanco
        let arr: any[] = [];
        let llaves = {};
        arr.push(llaves);

        let arrLlaves =
          '  "FILTROS_OPCIONALES"   : [{}]' +
          ', "FILTROS_OBLIGATORIOS" : ' +
          JSON.stringify(this.WsLlaves);

        // Armo el JSON
        let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
        this.dataService.ConsultarWS(url, json).subscribe(
          (datosResp: any) => {
            // Recargo los datos de la lista MODAL
            this.toolbarcampomodal = datosResp.Toolbar;
            this.form_template$ = this.retornaObservable(datosResp.CamposMS);
            this.modalService.open(this.contenidocampo, { size: "xl" });
          },
          (error) => {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-4">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-8">' +
                "<h3>Error</h3><br>" +
                " <p>" +
                error +
                "</p>" +
                " </div> ",
            });
          }
        );
        // this.AbrirURL(json);
      }
      this.checktodos(false);
    } else if (clicked.target.id == "INSERT_LISTA_SELECCION") {
      this.WsLlavesModal = this.WsLlaves;
      this.strWsURLModal = url;
      this.modalService.open(this.contenido, { size: "xl" });
    } else if (clicked.target.id == "EXPORTAR") {
      const arr = {
        FILTROS_OBLIGATORIOS: [],
        FILTROS_OPCIONALES: []
      };

      const filtrosActuales =
        this.child?.DemeFormulario() ??
        this.formFiltros ??
        {};

      this.formFiltros = filtrosActuales;

      if (this.WsLlaves && this.WsLlaves.length > 0) {
        arr.FILTROS_OBLIGATORIOS = this.WsLlaves;
      } else {
        arr.FILTROS_OBLIGATORIOS = [{}];
      }

      arr.FILTROS_OPCIONALES = [
        {
          ...this.formatearFormulario({ ...filtrosActuales })
        }
      ];

      const json = this.toJSON(clicked.target.id, arr, url);

      this.dataService.ConsultarWS(url, JSON.stringify(json)).subscribe(
        (datosResp: any) => {
          if (datosResp.Tipo == "ARCHIVO") {
            const blob = this.dataURItoBlob(datosResp.ARCHIVO_B64, "XLS");
            let fileURL = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.download = "Exportar " + this.TituloPantalla + ".xls";
            link.href = fileURL;
            link.click();
          }
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
    } else if (clicked.target.id == "IMPRIMIR") {
      let parametros = url.split("/");
      let num = parametros.length;
      this.objChecks.forEach((objCheck) => {
        let arr: any[] = [];
        if (
          objCheck.nativeElement.checked &&
          objCheck.nativeElement.value != -1
        ) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          if (formato != "NAV") {
            this.VerReporte(
              parametros[num - 3],
              parametros[num - 2],
              parametros[num - 1],
              formato,
              arr
            );
          } else {
            this.AbrirReportePDFNav(
              parametros[num - 3],
              parametros[num - 2],
              parametros[num - 1],
              parametros[num - 4],
              arr
            );
          }
        }
      });
    } else if (clicked.target.id == "ABRIR_MS") {
      let arr: any[] = [];
      this.objChecks.forEach((objCheck) => {
        if (
          objCheck.nativeElement.checked &&
          objCheck.nativeElement.value != -1
        ) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
        }
      });

      // Armo el JSON
      let json = this.toJSON("SELECT", arr, url);

      // Emito el evento para abrir un nuevo tab
      this.AbrirURL(json);
    } else if (clicked.target.id == "SUBIR_XML") {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: "xl" });
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        this.dataService
          .ConsultarWS("api/archivos/recibir", JSON.stringify(files))
          .subscribe((datos) => {});
      });
    } else if (clicked.target.id == "INSERT_OPERACIONES") {
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves =
        '  "FILTROS_OPCIONALES"   : [{}]' +
        ', "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(this.WsLlaves);

      var jsonFiltros = this.toJSON(
        clicked.target.id,
        arr,
        null,
        null,
        arrLlaves
      );

      const btn = document.getElementById(clicked.target.id) as HTMLButtonElement;
      btn.disabled = true;
      var operacion = clicked.target.id;
      if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
      else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado";
      else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";
      this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
        (datosResp: any) => {
          this._fetchData();

          //alertas
          Swal.fire({
            toast: true,
            position: "bottom-end",
            icon: "success",
            text: operacion + " Correctamente",
            showConfirmButton: false,
            timer: 3000,
          });
          btn.disabled = false;
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-8">' +
              "<h3>  Error</h3>" +
              " <p> " +
              error +
              " </p>" +
              " </div> ",
          });
          btn.disabled = false;
        }
      );
    } else if (clicked.target.id == "CARGAR") {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: "xl" });
      this.modalRef.componentInstance.limite = 1;
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        if (files.length > 0) {
          let peticion = { LLAVES: this.obtenerLlaves(), ARCHIVOS: files };
          this.enviarPeticion(clicked.target.id, url, JSON.stringify(peticion));
        }
      });
    } else if (clicked.target.id == "DESCARGAR" ) {
      let peticion = {
        LLAVES: this.obtenerLlaves(),
        FILTROS: [this.child?.DemeFormulario()],
        FILTROS_OBLIGATORIOS: this.WsLlaves,
      };
      this.enviarPeticion(
        clicked.target.id,
        url,
        JSON.stringify(peticion),
        "descarga"
      );
    } else {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (
          objCheck.nativeElement.checked &&
          objCheck.nativeElement.value != -1
        ) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          for (const col of this.ColumnasSN) {
            for (const i in this.tableData2) {
              if (this.tableData2[i].INDEX == index) {
                llaves[col.A03COD] = String(
                  this.tableData2[i][col.A03COD]
                ).replaceAll(",", "");
                if (this.tableData3.length > 0) {
                  let valoresCampo = this.tableData3.find(
                    (element) => element.codigo == col.A03COD
                  );
                  console.log(valoresCampo, "valoresCampo");
                  if (valoresCampo != null) {
                    for (const key in valoresCampo.des) {
                      console.log(valoresCampo.des[key], "valoresCampo[key]");
                      console.log(llaves[col.A03COD], "llaves[col.A03COD]");
                      if (valoresCampo.des[key].A09DES == llaves[col.A03COD]) {
                        llaves[col.A03COD] = valoresCampo.des[key].A09COD;
                        break;
                      }
                    }
                  }
                }
                break;
              }
            }
          }
          arr.push(llaves);
          blnExiste = true;
        }
      });
      if (blnExiste) {
        let arrLlaves =
          '  "FILTROS_OPCIONALES"   : [{}]' +
          ', "FILTROS_OBLIGATORIOS" : ' +
          JSON.stringify(this.WsLlaves);
        var jsonFiltros = this.toJSON(
          clicked.target.id,
          arr,
          null,
          null,
          arrLlaves
        );
        var operacion = clicked.target.id;
        if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
        else if (operacion == "UPDATE_GENERICO")
          operacion = "Campo Actualizado";
        else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";

        if (
          clicked.target.id == "DELETE_GENERICO" ||
          clicked.target.id == "DELETE_WS" ||
          clicked.target.id == "ANULAR"
        ) {
          var mensaje = "Está seguro de Eliminar?";
          if (operacion.Evento == "ANULAR") mensaje = "Está seguro de anular?";

          Swal.fire({
            title: mensaje,
            text: "No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "No, cancelar!",
            confirmButtonText:
              clicked.target.id == "ANULAR" ? "Si, anularlo" : "Si, eliminarlo",
          }).then((result) => {
            if (result.isConfirmed) {
              this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
                (datosResp: any) => {
                  this._fetchData();

                  //alertas
                  Swal.fire({
                    toast: true,
                    position: "bottom-end",
                    icon: "success",
                    text: operacion + " Correctamente",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                },
                (error) => {
                  Swal.fire({
                    html:
                      '<div class="row" style="width:100%; overflow:auto;"> ' +
                      '<div class="col-4">' +
                      ' <img src="assets/images/imageerror.png"> </img>' +
                      "</div>" +
                      ' <div class="col-8">' +
                      "<h3>  Error</h3>" +
                      " <p> " +
                      error +
                      " </p>" +
                      " </div> ",
                  });
                }
              );
            }
          });
        } else {
            let filtrosBusqueda = this.child?.DemeFormulario();
            let peticion = {
              LLAVES: arr,
              FILTROS: [],
              FILTROS_OBLIGATORIOS: this.WsLlaves,
            };
            
            if (filtrosBusqueda != null) {
              peticion.FILTROS = [filtrosBusqueda];
            }
            
            this.enviarPeticion(operacion, url, JSON.stringify(peticion));
        }
      } else {
        Swal.fire(
          "Error",
          "Debe seleccionar los registros con los que desea trabajar",
          "error"
        );
      }
    }
  }

  obtenerLlaves() {
    let arr = [];
    this.objChecks.forEach((objCheck) => {
      if (
        objCheck.nativeElement.checked &&
        objCheck.nativeElement.value != -1
      ) {
        let index = objCheck.nativeElement.value;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
      }
    });

    return arr;
  }

  enviarPeticion(operacion, url, jsonFiltros, descarga?) {
    this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
      (datosResp: any) => {
        this.BuscarAvanzado();
      
        if (descarga == null) {
          //alertas
          Swal.fire({
            toast: true,
            position: "bottom-end",
            icon: "success",
            text: operacion + " Correctamente",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (datosResp != null) {
          const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
          let fileURL = URL.createObjectURL(blob);
          if (datosResp.tipo == "application/pdf") {
            window.open(fileURL, "_blank");
          } else {
            let link = document.createElement("a");
            if (datosResp.nombre != null) {
              link.download = datosResp.nombre;
            } else {
              let tipoPartes = datosResp.tipo.split("/");
              if (tipoPartes.length > 1) {
                link.download = "documento." + tipoPartes[1];
              } else {
                link.download = "documento";
              }
            }
            link.href = fileURL;
            link.click();
          }
        }
      },
      (error) => {
        Swal.fire({
          html:
            '<div class="row" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-8">' +
            "<h3>  Error</h3>" +
            " <p> " +
            error +
            " </p>" +
            " </div> ",
        });
      }
    );
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }
      if (Array.isArray(form[key])) {
        form[key] = "'" + form[key].join("','") + "'";
      }
      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }

      let elemento = this.getObtenerCodigoCampo(key);
      if (elemento.A03TIP === "datetime" && form[key] != "") {
        form[key] = formatDate(form[key], "dd/MM/yyyy", "en");
      }
    }
    return form;
  }

  getObtenerCodigoCampo(label) {
    for (const i in this.estructura) {
      if (this.estructura[i].A03COD == label) {
        return this.estructura[i];
      }
    }
    return null;
  }

  toJSON(
    operacion: string,
    arr: any,
    url?: string,
    titulo?: string,
    extra?: any
  ) {
    let NavID = (
      Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
    ).toUpperCase();
    return JSON.parse(
      '{ "LLAVES"   :' +
        JSON.stringify(arr) +
        (url != null ? ', "URL"      :"' + url + '"' : "") +
        (titulo != null ? ', "TITULO"      :"' + titulo + '"' : "") +
        (extra != null ? "," + extra : "") +
        ', "NAV_ID"   : "' +
        NavID +
        '"' +
        ', "OPERACION": "' +
        operacion +
        '"}'
    );
  }

  isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }

  EjecutarAccion(arr: any[], i: number, b) {
    if (arr.length > 0) {
      var jsonFiltros = this.toJSON(this.operaciones[i].Evento, arr);

      this.dataService
        .ConsultarWS(this.operaciones[i].URL, jsonFiltros)
        .subscribe(
          (datosResp: any) => {
            if (b != false) this._fetchData();
          },
          (error) => {
            Swal.fire({
              title: "Error",
              text: error,
              icon: "error",
            });
          }
        );
    } else {
      alert("Debe seleccionar los registros a eliminar");
    }
  }

  // almora 2021.10.31 EventoClickLista() se usa tanto para el click normal como para el click modal
  EventoClickLista(event, index) {
    if (this.mostrarModal) {
      let arr: any[] = [];
      let llaves = this.DemeLlavesIndexJSON(index);
      arr.push(llaves);
      this.RetornoModal.emit(arr);
    } else {
      if (this.permitir_click_lista == "S") {
        let arr: any[] = [];
        let llaves = this.DemeLlavesIndexJSON(index);
        for (const property in this.WsLlaves[0]) {
          if (llaves[property] == null) {
            llaves[property] = this.WsLlaves[0][property];
          } else {
            llaves[property + "_1"] = this.WsLlaves[0][property];
          }
        }
        arr.push(llaves);

        // Armo el JSON
        let json = this.toJSON("SELECT", arr, this.UrlClickLista);

        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(json);
      }
    }
  }

  // almora 2021.10.31 EventoClickOperacion(), se usa para el click en la lista de items del menú Operacion
  EventoClickOperacion(operacion: any, index) {
    for (let i = 0; i < this.operaciones.length; i++) {
      if (
        this.operaciones[i].Evento == operacion.Evento &&
        this.operaciones[i].URL != undefined
      ) {
        if (
          operacion.Evento == "UPDATE_GENERICO" &&
          this.permitir_click_lista == "S"
        ) {
          let arr: any[] = [];
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);

          var jsonFiltros = this.toJSON("SELECT", arr, this.operaciones[i].URL);

          // Emito el evento para abrir un nuevo tab
          this.AbrirURL(jsonFiltros);
        } else if (operacion.Evento == "EDITAR_LINEA") {
          let arr: any[] = [];
          let llaves = this.DemeCamposIndexJSON(index);

          let inputs = document.getElementsByClassName(index);
          for (const key in inputs) {
            if (inputs[key].id != undefined) {
              let attr = inputs[key].id.split("+");
              let inputVal = (<HTMLInputElement>(
                document.getElementById(inputs[key].id)
              )).value;
              llaves[attr[0]] = inputVal.replaceAll(",", "");
              if (llaves[attr[0]] === "") {
                llaves[attr[0]] = "0";
                (<HTMLInputElement>(
                  document.getElementById(inputs[key].id)
                )).value = "0";
              }
            }
          }
          arr.push(llaves);
          this.EjecutarAccion(arr, i, false);

          document.getElementById(index).style.display = "none";

          if (this.UrlBottomBar.length > 0 || this.UrlBottomBar != "") {
            this.Botonbar(this.WsLlaves);
          }
        } else if (operacion.Evento == "IMPRIMIR") {
          let arr: any[] = [];
          let llaves = this.DemeLlavesIndexJSON(index);

          arr.push(llaves);
          let parametros = this.operaciones[i].URL.split("/");
          let num = parametros.length;
          this.VerReporte(
            parametros[num - 3],
            parametros[num - 2],
            parametros[num - 1],
            "PDF",
            arr
          );
        } else if (operacion.Evento == "ABRIR_MS") {
          let arr: any[] = [];
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);

          // Armo el JSON
          let json = this.toJSON("SELECT", arr, operacion.URL);

          // Emito el evento para abrir un nuevo tab
          this.AbrirURL(json);
        } else if (
          operacion.Evento == "DELETE_WS" ||
          operacion.Evento == "DELETE_GENERICO"
        ) {
          Swal.fire({
            title: "Estás seguro de Eliminar?",
            text: "No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "No, cancelar!",
            confirmButtonText: "Si, eliminarlo!",
          }).then((result) => {
            if (result.isConfirmed) {
              let arr: any[] = [];
              let llaves = this.DemeLlavesIndexJSON(index);
              arr.push(llaves);

              this.EjecutarAccion(arr, i, true);
            }
          });
        } else {
          let arr: any[] = [];
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);

          this.EjecutarAccion(arr, i, true);
        }
        break;
      }
    }
  }

  DemeLlaves(data) {
    let arr: Array<string[]> = [];
    for (let i = 0; i < this.llaves.length; i++) {
      let llave = this.llaves[i];
      let valor = data[llave];

      let x: string[] = [llave, valor];
      arr.push(x);
    }
    return arr;
  }

  DemeLlavesIndexJSON(index) {
    let row = null;

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        row = this.tableData2[key];
        break;
      }
    }
    var arr = {};
    for (let i = 0; i < this.llaves.length; i++) {
      let llave = this.llaves[i];

      let encontro = false;
      let valor = "";
      for (let j = 0; j < this.tableData3.length; j++) {
        if (llave == this.tableData3[j].codigo) {
          valor = this.tableData3[j].des.find(
            (element) => element.A09DES == row[llave]
          );
          valor = valor["A09COD"];
          encontro = true;
          break;
        }
      }
      if (encontro == false && row != null) {
        valor = row[llave];
      }
      arr[llave] = valor;
    }

    return arr;
  }

  DemeCamposIndexJSON(index) {
    let row = null;

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        row = this.tableData2[key];
        break;
      }
    }
    var arr = {};

    for (var i in row) {
      for (let j = 0; j < this.tableData3.length; j++) {
        if (i == this.tableData3[j].codigo) {
          var valor = "";
          valor = this.tableData3[j].des.find(
            (element) => element.A09DES == row[i]
          );
          valor = valor["A09COD"];
          row[i] = valor;
          break;
        }
      }
    }

    return row;
  }

  pageChange(event) {
    this.currentPage = event;
  }

  countNumber(event: any) {
    this.itemsPerPage = event;
  }

  dataURItoBlob(dataURI, strFORMATO, strType = "application/pdf") {
    if (strFORMATO == "XLS")
      strType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (strFORMATO == "application/xml") {
      strType = "application/xml";
    }
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  VerReporte(
    intSYS02CON: string,
    intSYS10CON: string,
    intTSTAMP: string,
    strFORMATO: string,
    llaves?
  ) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    let strjson =
      '{    "FILTROS_OPCIONALES"   : [' +
      JSON.stringify(this.formFiltros == null ? this.WsLlaves[0] : this.formFiltros) +
      "]" +
      ' , "SYS02CON"   : "' +
      intSYS02CON +
      '" ' +
      ' , "SYS10CON"   : ' +
      intSYS10CON +
      ' , "FORMATO"    : "' +
      strFORMATO +
      '" ' +
      ' , "TSTAMP"     : ' +
      intTSTAMP +
      ' , "TITULO"     : ""' +
      ' , "FILTROS_DASHBOARD"    : [] ' +
      ' , "FILTROS_OBLIGATORIOS" : ' +
      JSON.stringify(llaves) +
      "}";

    let arr = JSON.parse(strjson);
    let json = this.toJSON(
      "ABRIR_REPORTE_PDF",
      arr,
      "api/mantenimientos/VerReporte/" +
        intSYS02CON +
        "/" +
        intSYS10CON +
        "/" +
        intTSTAMP,
      ""
    );

    this.dataService
      .ConsultarWS(
        "api/mantenimientos/VerReporte/" +
          intSYS02CON +
          "/" +
          intSYS10CON +
          "/" +
          intTSTAMP,
        json
      )
      .subscribe(
        (datosResp: any) => {
          const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
          const blob = this.dataURItoBlob(base64, strFORMATO);
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, "_blank");
        },
        (error) => {
          this.tipoReporte = null;
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  // AbrirReportePDFNav
  // Método para abrir un PDF en una cejilla
  AbrirReportePDFNav(
    intSYS02CON: string,
    intSYS10CON: string,
    intTSTAMP: string,
    strSYS10DES: string,
    llaves?
  ) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    let arr = JSON.parse(
      '{    "FILTROS_OPCIONALES"   : [' +
        JSON.stringify(this.formFiltros) +
        "]" +
        ' , "SYS02CON"   : "' +
        intSYS02CON +
        '" ' +
        ' , "SYS10CON"   : ' +
        intSYS10CON +
        ' , "FORMATO"    : "PDF" ' +
        ' , "TSTAMP"     : ' +
        intTSTAMP +
        ' , "TITULO"     : "' +
        strSYS10DES +
        '"' +
        ' , "FILTROS_DASHBOARD"    : [] ' +
        ' , "FILTROS_OBLIGATORIOS" : ' +
        JSON.stringify(llaves) +
        "}"
    );

    // Armo el JSON
    let json = this.toJSON(
      "ABRIR_REPORTE_PDF",
      arr,
      "api/mantenimientos/VerReporte/" +
        intSYS02CON +
        "/" +
        intSYS10CON +
        "/" +
        intTSTAMP,
      strSYS10DES
    );
    this.AbrirNuevoNav.emit(json);
  }

  // AbrirReporteComponentePDFNav
  // Este metodo abre el reporte cuando se llama desde app-reportes
  AbrirReporteComponentePDFNav(json) {
    this.AbrirNuevoNav.emit(json);
  }

  RetornoModalLista(event) {
    // Este metodo se llama en el Cerrar de la Lista Modal
    this._fetchData();
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.currentPDF);
  }

  ordenasc(val) {
    this.tableData2.sort((a, b) => a[val] - b[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
    this.order_mostrar = false;
  }

  ordendes(val) {
    this.tableData2.sort((a, b) => b[val] - a[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
    this.order_mostrar = true;
  }

  // limpio
  // almora 2021.11.06 Se ejecuta OK
  ngOnDestroy(): void {
    if (this.mostrarModal) {
      this.RetornoModal.emit(JSON.parse("{  }"));
    }
    this.form_template$ = of([]);
    this.estructura = of([]);

    if (this.suscription != null) this.suscription.unsubscribe();
    this.llaves = [];
    this.ColumnasSN = [];
    this.reportes = [];
    this.boton = [];
    this.evento = [];
    this.tooltip = [];
  }

  EventoCerrarMSInterno(blnRefrescar: boolean) {
    this.WsMsDataInterno = "";
    if (blnRefrescar) this._fetchData();
  }

  GrabarFavorito() {
    if (this.favorito_pantalla == "N") {
      this.EventoWsInsert();
    } else {
      this.EventoWsDelete();
    }
  }

  EventoWsInsert() {
    this.dataService
      .ConsultarWS("api/mantenimientos/Favoritos/ADD/" + this.intSYS02CON)
      .subscribe(
        (datosResp: any) => {
          // almora 202.03.21 No necesito recargar la página
          this.favorito_pantalla = "S";
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "Dato Grabado exitosamente",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  EventoWsDelete() {
    this.dataService
      .ConsultarWS("api/mantenimientos/Favoritos/DEL/" + this.intSYS02CON)
      .subscribe(
        (datosResp: any) => {
          // almora 202.03.21 No necesito recargar la página
          this.favorito_pantalla = "N";
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "Dato Eliminado exitosamente",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
  }

  EventoClickBuscar(col, btn) {
    this.blnFiltrosAbiertos = !this.blnFiltrosAbiertos;
    this.Mostrartitulofiltro = true;
  }

  EventoClickBuscarHt(col, btn) {
    this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    this.Mostrartitulofiltro = true;
  }

  Mostrarboton(index) {
    this.lineaEditar = index;
  }

  buscardes(event, campo, index, sys03edi, UrlOnChange) {
    if (sys03edi != "S" || UrlOnChange == "") return;
    let campos = {};

    for (const col of this.ColumnasSN) {
      for (const i in this.tableData2) {
        if (this.tableData2[i].INDEX == index) {
          campos[col.A03COD] = String(
            this.tableData2[i][col.A03COD]
          ).replaceAll(",", "");
          break;
        }
      }
    }

    // Agrego las llaves
    for (const col of this.llaves) {
      for (const i in this.tableData2) {
        if (this.tableData2[i].INDEX == index) {
          campos[col] = String(this.tableData2[i][col]).replaceAll(",", "");
          break;
        }
      }
    }

    campos[campo] = event.target.value;

    let jsonFiltros = { LLAVES: [campos], OPERACION: "BUSCAR_DESCRIPCION" };

    this.dataService
      .ConsultarWS(UrlOnChange, JSON.stringify(jsonFiltros))
      .subscribe(
        (datosResp: any) => {
          if (datosResp.NOTIFICACION != "") {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/image-notifiacion.jpg"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h3>Advertencia</h3><br>" +
                " <p>" +
                datosResp.NOTIFICACION +
                "</p>" +
                " </div> ",
            });
          }
          for (const key in this.tableData2) {
            if (this.tableData2[key].INDEX == index) {
              let keys = Object.keys(datosResp.DATA[0]);
              for (const k in keys) {
                this.tableData2[key][keys[k]] = datosResp.DATA[0][keys[k]];
              }
            }
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
  }

  obtener_localstorage() {
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.M05COD = localStorage.getItem("X-AVATAR-M05COD");
    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");
    this.MostrarFiltroPrincipal = localStorage.getItem(
      "X-AVATAR-MOSTRARFILTRO"
    );

    if (
      this.CNT05COD == "" ||
      this.CNT05COD == undefined ||
      this.M05COD == "" ||
      this.M05COD == undefined
    ) {
      Swal.fire({
        title: "Error",
        text: "Por favor Seleccione una Compañia y Sede",
        icon: "error",
      });
      this.menuEvent.abrirmodalcompaniaysede("");
      this.mostrarbreitem = true;
    } else {
      this.mostrarbreitem = false;
    }
  }

  isNumber(numero: string) {
    let diferente = Number(numero);
    if (isNaN(diferente)) {
      return false;
    } else {
      if (diferente > 1900 && diferente < 2100) {
        return false;
      }
      return true;
    }
  }

  checktodos(event) {
    let bandera = false;
    if (event.target) {
      // almora 2023.04.13 Fix
      if (event.target.checked) {
        bandera = true;
      }
    }
    for (let index = 0; index < this.tableData2.length; index++) {
      this.tableData2[index].checkado = bandera;
    }
  }

  obtenerBusqueda(strListener) {
    let filtro = localStorage.getItem("busqueda" + strListener);

    if (filtro != null) {
      return filtro;
    } else {
      return null;
    }
  }

  GuardarFiltro() {
    if (this.formFiltros != null) {
      Swal.fire({
        title: "Nombre del Filtro",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          let objForm = this.formatearFormulario(this.formFiltros);
          let strjson = {
            SYS20FIL: objForm,
            SYS20COD: "",
            SYS20DES: result.value,
            SYS02CON: this.intSYS02CON,
          };
          let strjson2 = [strjson];
          let url = "api/filtros/Grabar/ADD/" + this.intSYS02CON;
          // Armo el JSON
          let json = this.toJSON("ADD", strjson2, url);
          this.dataService.ConsultarWS(url, json).subscribe(
            (datosResp: any) => {
              this.Select_grabar;
              Swal.fire({
                position: "bottom-end",
                toast: true,
                icon: "success",
                text: "Dato Grabado exitosamente",
                showConfirmButton: false,
                timer: 5000,
              });
            },
            (error) => {
              Swal.fire({
                title: "Error",
                text: error,
                icon: "error",
              });
            }
          );
        }
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Debe aplicar un filtro primero",
        icon: "error",
      });
    }
  }

  DELETE_FILTRO() {
    if (this.filtroSel != null) {
      let strjson = [
        {
          SYS20FIL: {},
          SYS20COD: this.filtroSel.SYS20COD,
          SYS20DES: "",
          SYS02CON: this.intSYS02CON,
        },
      ];

      let url = "api/filtros/Grabar/DEL/" + this.intSYS02CON;
      let json = this.toJSON("DEL", strjson, url);
      this.dataService.ConsultarWS(url, json).subscribe(
        (datosResp: any) => {
          this.filtroSel = null;
          this.filtro_guardado = datosResp.DATA;
          this.Select_grabar;
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "Dato Eliminado exitosamente",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        (error) => {
          Swal.fire({
            title: "Error",
            text: error,
            icon: "error",
          });
        }
      );
    }
  }

  onFilter(event) {
    if (event != null) {
      this.formFiltros = event.SYS20FIL;
      this.formFiltros = this.formatearFormulario(this.formFiltros);
      this._fetchData(this.formFiltros);
    } else {
      this.formFiltros = null;
    }
  }

  limpiarbusqueda() {
    this.formFiltros = null;
    localStorage.removeItem("filtro" + this.intSYS02CON);
    localStorage.removeItem("busqueda" + this.intSYS02CON);
    this.child?.myFormGroup.reset();
    let limpiar = {};
    this._fetchData(limpiar);

    this.objChecks.forEach((objCheck) => {
      if (objCheck.nativeElement.checked) {
        let index = objCheck.nativeElement.value;
        if (index == -1) {
          objCheck.nativeElement.checked = false;
        }
      }
    });
  }

  hasItems(item) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  BuscarAvanzado() {
    if (this.respFiltros.length > 0) {
      if (this.respFiltros[0].FiltrosAvanzado.length > 0) {
        this.blnAccionbuscar++;
      }else{
        this._fetchData();
      }
    } else {
      if (this.formFiltros != null) {
        this._fetchData(this.formFiltros);
      } else {
        this._fetchData();
      }
    }
  }

  abrirAyuda() {

    // mospina 15-04-2026 se obtiene localstorage campo 
    let CLITUT = localStorage.getItem('CLITUT');

    if (this.SYS02TUT != null && this.SYS02TUT != '') {
      window.open(this.SYS02TUT + "?c=" + CLITUT, '_blank');
    }
  }
}
